
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import {
    RankingList,
    StatisticalData,
    deviceStatus,
    PdaUsercodename,
    DestinationOrgcodename,
    YtoTable,
    Scan
  } from "@/views/components";
  import deviceItem from "@/views/components/DeviceStatus/deviceItem";
  import TableHeaderConfig from "./config";
  import Form1 from "./Form1.vue";
  import Form2 from "./Form2.vue";
  // import FormPic from "./FormPic.vue";
  import TableHeader from "./TableHeader.vue";
  import {soundList} from "@/common/voiceLayer";

  // import {playLayerVioce} from "@/common/voiceLayer";
  @Component({
    name: "ScanforAcceptPacketShape1",
    components: {
      deviceStatus,
      RankingList,
      StatisticalData,
      PdaUsercodename,
      DestinationOrgcodename,
      YtoTable,
      Form1,
      Form2,
      TableHeader,
      Scan,
      // FormPic
    }
  })
  export default class extends Vue {
    @Prop() private getForm2Value;
    @Prop() private ranklistdata;
    @Prop() private statisticalList;
    @Prop() private deletedatahistory;
    @Prop() private callbackmodel;
    @Prop() private getFormValue;
    @Prop() private errormessage;
    @Prop() private deviceItems;
    @Prop() private inputModel;
    @Prop() private ytoCode;
    @Prop() private scanAreaCallback;
    @Prop() private selectElementContents;
    @Prop() private rowClassAction;
    @Prop() private showList;
    @Prop() private currentRowChanged;
    @Prop() private ytocodeget;

    private config = TableHeaderConfig;
  }
